import { render, staticRenderFns } from "./CuttingTask.vue?vue&type=template&id=3bb5f5a7&scoped=true"
import script from "./CuttingTask.vue?vue&type=script&lang=js"
export * from "./CuttingTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5f5a7",
  null
  
)

export default component.exports